(function waitForProbance() {

    const originalFetch = window.fetch;

    window.fetch = async function(resource, config) {
        const response = await originalFetch(resource, config);

        try {
            const url = new URL(resource, window.location.origin);

            if (
                url.pathname.includes('/cart') &&
                url.searchParams.get('section_id') === 'mini-cart'
            ) {
                console.debug("[Intercept] mini-cart fetch → scheduling pollAllRecosContent()");

                // On attend 300 ms avant d'appeler la fonction
                setTimeout(() => {
                    try {
                        probanceRoS.pollAllRecosContent();
                    } catch (e) {
                        console.error("Error calling pollAllRecosContent:", e);
                    }
                }, 300);
            }
        } catch (e) {
            console.warn("Error intercepting fetch:", e);
        }

        return response;
    };

    console.debug("Fetch interceptor installed!");
})();

// Empêche la redirection sur la page panier
document.addEventListener('click', function(e) {
    // On vérifie si le clic est sur un bouton p-ros-carousel dans le banner_widget
    const btn = e.target.closest('div[p-ros-banner="banner_widget"] button[class^="p-ros-carousel"]');
    if (btn) {
        e.preventDefault();    // empêche l'action par défaut
        e.stopPropagation();   // empêche la propagation
        console.log('Clic sur le bouton bloqué !');
    }
});